module.exports = __webpack_public_path__ + "static/media/coaches-icon-active.01ae737c.svg";